/**
 * cart-checkout-guard.js
 *
 * Gemeinsame Registry, über die mehrere unabhängige Warenkorb-Prüfungen
 * (Prämien-Auswahl, Studentennachweis, künftige weitere Checks) den
 * "Zur Kasse"-Button gemeinsam sperren können, ohne sich gegenseitig
 * zu überschreiben. Zeigt zusätzlich eine sichtbare Sammel-Meldung mit
 * den konkreten Gründen an, damit der Nutzer versteht warum er nicht
 * weiterkommt.
 *
 * Nutzung durch andere Scripts:
 *   window.cartCheckoutGuard.setBlocker('praemien', true, 'Bitte wählen Sie Ihre Prämie aus.');
 *   window.cartCheckoutGuard.setBlocker('praemien', false);
 */

(function () {
  const blockerZustand = {};
  const blockerGruende = {};

  function anwenden() {
    const button = document.getElementById('checkout');
    const hinweis = document.getElementById('cart-checkout-blocked-hinweis');
    const gesperrt = Object.values(blockerZustand).some(Boolean);

    if (button) {
      button.disabled = gesperrt;
      button.classList.toggle('cart__checkout-button--praemien-blockiert', gesperrt);
    }

    // Express-Checkout-Buttons (Shop Pay, PayPal, Apple Pay ...) umgehen
    // den #checkout-Button. Sie werden von Shopify in einem eigenen
    // Container gerendert (teils iframes) und lassen sich nicht per
    // disabled sperren. "inert" blockiert Klicks UND Tastatur-Fokus im
    // ganzen Container, die CSS-Klasse sorgt für die ausgegraute Optik.
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (container) {
      container.inert = gesperrt;
      container.classList.toggle('cart__express-blockiert', gesperrt);
      container.setAttribute('aria-disabled', gesperrt ? 'true' : 'false');

      // Die Hülle (außerhalb des inert-Containers) zeigt den Sperr-Mauszeiger
      // und fängt Klicks zusätzlich ab, auch in Browsern ohne inert-Unterstützung.
      const huelle = container.closest('.cart__express-huelle');
      if (huelle) huelle.classList.toggle('cart__express-blockiert', gesperrt);
    });

    if (hinweis) {
      const aktiveGruende = Object.keys(blockerZustand)
        .filter(function (name) { return blockerZustand[name]; })
        .map(function (name) { return blockerGruende[name]; })
        .filter(Boolean);

      if (aktiveGruende.length > 0) {
        hinweis.textContent = aktiveGruende.join(' ');
        hinweis.classList.add('cart__checkout-blocked-hinweis--sichtbar');
      } else {
        hinweis.textContent = '';
        hinweis.classList.remove('cart__checkout-blocked-hinweis--sichtbar');
      }
    }
  }

  window.cartCheckoutGuard = {
    setBlocker: function (name, istBlockiert, grund) {
      blockerZustand[name] = !!istBlockiert;
      if (grund) blockerGruende[name] = grund;
      anwenden();
    },
  };

  // Das Theme ersetzt bei Mengenänderungen (+/- bzw. Entfernen) den
  // Warenkorb-Bereich per Ajax und meldet das danach über 'cart-update'.
  // Die frisch gerenderten Elemente brauchen dann erneut ihre Listener
  // bzw. Dropdown-Optionen. Event-basiert statt MutationObserver, damit
  // keine Endlosschleife durch eigene DOM-Änderungen entstehen kann.
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () {
      anwenden();
    });
  }
})();
